module.exports = new __parcel__URL__("eurobricks.7a7caab3.png").toString();